import React, { FunctionComponent, ReactNode } from 'react'

// Applied to the <input> that sits beside a <StartAdornment>. Its left padding
// is derived from the adornment's width (see atoms/_forms.scss), so inputs
// don't carry a hardcoded pixel value.
export const START_ADORNMENT_INPUT_CLASS = 'has-start-adornment'

// Fixed, non-interactive text shown inside the left edge of an input
// (e.g. the "+1" country code beside phone numbers). Render it inside a
// position: relative container.
export const StartAdornment: FunctionComponent<{ children: ReactNode }> = ({
  children,
}) => <span className="start-adornment">{children}</span>

// Convenience wrapper for inputs that don't go through <InputField>.
export const StartAdornmentField: FunctionComponent<{
  adornment: ReactNode
  children: ReactNode
}> = ({ adornment, children }) => (
  <div className="start-adornment-field">
    <StartAdornment>{adornment}</StartAdornment>
    {children}
  </div>
)
